const lang = {
    English: {
        search: 'Search',
        searchBarPlaceholder: 'What genre would you like to watch today?'
    },
    Hindi: {
        search: 'खोज',
        searchBarPlaceholder: 'आज आप कौन सी शैली देखना चाहेंगे?'
    },
    Japanese: {
        search: '検索',
        searchBarPlaceholder: '今日はどのジャンルを見たいですか？'
    }, 
    French: {
        search: 'recherche',
        searchBarPlaceholder: 'Quel genre aimeriez-vous regarder aujourd’hui ?'
    }, 
    Italian: {
        search: 'ricerca',
        searchBarPlaceholder: 'che genere ti piacerebbe guardare oggi?'
    }
}
export default lang;